import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { HeaderComponent } from "@components/header/header.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { GruppWithFragor } from "../../models/checklist-models";
import { ChecklistMediatorService } from "../../services/checklist-mediator.service";
import { KontraktChecklistGruppComponent } from "./kontrakt-checklist-grupp/kontrakt-checklist-grupp.component";

@Component({
    selector: "rask-kontrakt-checklist",
    templateUrl: "./kontrakt-checklist.component.html",
    styleUrl: "./kontrakt-checklist.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TogglePanelComponent,
        HeaderComponent,
        TabsComponent,
        TabComponent,
        KontraktChecklistGruppComponent
    ]
})
export class KontraktChecklistComponent implements OnInit {
    protected readonly headerText = "Alla punkter förväntas utföras enligt aktuell instruktion";

    private readonly checklistMediatorService = inject(ChecklistMediatorService);

    protected get checklisteFragor() { return this.checklistMediatorService.checklisteFragor; }

    protected get grupperWithFragor() { return this.checklistMediatorService.grupperWithFragor; }

    protected get numberOfSelectedFragor() { return this.checklistMediatorService.numberOfSelectedFragor; }

    ngOnInit(): void {
        this.checklistMediatorService.getChecklisteFragor();
    }

    protected getTabIcon(grupp: GruppWithFragor): string {
        const { fragor } = grupp;
        const allSelected = fragor.every(f => f.selected);
        const noneSelected = fragor.every(f => !f.selected);

        if (allSelected) {
            return "fas fa-circle-check";
        }

        if (noneSelected) {
            return "far fa-circle";
        }

        return "fas fa-circle-half-stroke fa-rotate-270";
    }
}
